export enum Roles {
	USUARIO_SUPORTE = "USUARIO_SUPORTE",
	USUARIO_GRUPO = "USUARIO_GRUPO",
	USUARIO_CONTADOR = "USUARIO_CONTADOR",
	USUARIO_ADM = "USUARIO_ADM"
}
